var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',_vm._b({class:{ 'sf-link': _vm.type == _vm.TYPES.LINK, 'sf-btn': _vm.type == _vm.TYPES.BUTTON },attrs:{"href":_vm.link}},'a',_vm.$attrs,false),[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }